const testimonialData = [
  {
    id: 1,
    name: '田中 美咲様',
    age: 32,
    area: '岡山市北区',
    comment: 'いつも丁寧にカウンセリングしていただき、自分に似合うスタイルを提案してくださいます。スタッフの皆さんも親切で、リラックスして施術を受けられます。岡山市で美容室を探している方に自信を持っておすすめできるサロンです。',
    rating: 5,
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/01c525acb696c4260cc4f76daffc5b9c.jpeg',
  },
  {
    id: 2,
    name: '佐藤 恵子様',
    age: 45,
    area: '岡山市中区',
    comment: '髪質や顔立ちに合わせて、最適なスタイルを提案してくれるので安心してお任せできます。トリートメントの効果も素晴らしく、髪がツヤツヤになりました。これからもずっと通い続けたいと思える美容室です。',
    rating: 5,
    image: 'https://public.readdy.ai/ai/img_res/63886b3f8fbe2d230c3af849b9fcb434.jpg',
  },
  {
    id: 3,
    name: '山本 由美様',
    age: 28,
    area: '岡山市南区',
    comment: '初めての来店でしたが、スタッフの方が親身になって相談に乗ってくださり、理想通りのスタイルに仕上げていただきました。技術力の高さと丁寧な接客に感動しました。友人にもぜひ紹介したいです。',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=cheerful%20japanese%20woman%20in%20her%20late%20twenties%20with%20trendy%20hairstyle%20smiling%20brightly%2C%20professional%20portrait%20in%20contemporary%20hair%20salon%2C%20fresh%20and%20youthful%20appearance%2C%20simple%20clean%20background%20in%20soft%20cream%20tones%2C%20delighted%20customer%20testimonial%20photo%20in%20okayama%20beauty%20salon&width=400&height=400&seq=testimonial003&orientation=squarish',
  },
  {
    id: 4,
    name: '鈴木 真理子様',
    age: 38,
    area: '岡山市東区',
    comment: '長年通っていますが、いつも満足のいく仕上がりです。最新のトレンドも取り入れながら、私に似合うスタイルを提案してくれます。アットホームな雰囲気も気に入っています。岡山市で信頼できる美容室です。',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20japanese%20woman%20in%20her%20late%20thirties%20with%20stylish%20hairstyle%20looking%20pleased%2C%20professional%20portrait%20in%20elegant%20hair%20salon%2C%20refined%20and%20polished%20appearance%2C%20simple%20clean%20background%20in%20soft%20ivory%20tones%2C%20loyal%20customer%20testimonial%20photo%20in%20okayama%20beauty%20salon&width=400&height=400&seq=testimonial004&orientation=squarish',
  },
];

export default function TestimonialSection() {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-accent/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 tracking-wider text-sub" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            VOICE
          </h2>
          <p className="text-sm sm:text-base text-sub/70 tracking-widest" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            お客様の声
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {testimonialData.map((testimonial) => (
            <article key={testimonial.id} className="bg-white rounded-lg p-6 sm:p-8 shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-start gap-4 sm:gap-6 mb-6">
                <div className="relative w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden flex-shrink-0 shadow-md">
                  <img
                    src={testimonial.image}
                    alt={`${testimonial.name}様 - おかやま美容室のお客様`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="text-base sm:text-lg font-bold mb-1 text-sub" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    {testimonial.name}
                  </h3>
                  <p className="text-xs sm:text-sm text-sub/70 mb-2">
                    {testimonial.age}歳 / {testimonial.area}
                  </p>
                  <div className="flex gap-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-primary text-base w-4 h-4 flex items-center justify-center"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-sub/80 leading-relaxed">
                {testimonial.comment}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
